module.exports = __webpack_public_path__ + "static/media/imagem.32297a05.png";